module.exports = "/_next/static/images/03f30e68700d8cef97b29ab047edb09e-clips@desktop1366.jpg";